import {
  getModule,
  Action,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { informationService } from "@/app/services/InformationService";
import { messageService } from "@/app/services/MessageService";
import { UnreadMessageCount } from "@/types/order/UnreadMessageCount";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "message"
})
class MessageModule extends VuexModule {
  unreadMessageCount = 0;
  unreadInformationCount = 0;

  @Mutation
  SET_UNREAD_MESSAGE_COUNT(count: number) {
    this.unreadMessageCount = count;
  }

  @Mutation
  SET_UNREAD_INFORMATION_COUNT(count: number) {
    this.unreadInformationCount = count;
  }

  @Action
  async fetchUnreadMessageCount() {
    const count = (await messageService.countUnreadMessages()).reduce(
      (totalCount: number, c: UnreadMessageCount) => totalCount + c.count,
      0
    );
    this.SET_UNREAD_MESSAGE_COUNT(count);
  }
  @Action
  async fetchUnreadInformationCount() {
    const count = await informationService.fetchUnreadCount();
    this.SET_UNREAD_INFORMATION_COUNT(count);
  }
}

export const messageStore = getModule(MessageModule);
